export default __webpack_public_path__ + "static/media/accordion-background.26c11b47.png";